import React, { FC, ReactNode } from 'react';
import {
  Col,
  Flex,
  FlexRow,
  HighlightedHeader,
} from '@edreamsodigeo/prisma-design-system';
import {
  DEAL_WEEKEND,
  DEAL_HOTTEST,
} from 'clientState/hooks/useGetBuyPathDeal';
import { DealHeader } from '../../Deals/DealHeader';
import Reprice from '../../Reprice';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import useDisplayTypeBySite from 'clientState/hooks/useDisplayTypeBySite/useDisplayTypeBySite';

export type ItineraryHeaderRevampProps = {
  highlightedType: string | undefined;
};

type HeaderComponentProps = {
  highlightedType: string;
  children: ReactNode;
  sx: unknown;
};

type HighlightedMessageProps = {
  type: string;
};

const HeaderComponent: FC<HeaderComponentProps> = ({
  highlightedType,
  children,
}) => {
  const type = highlightedType === 'metaSelection' ? 'branded' : 'positive';
  const size = ['metaSelection', 'recommended'].includes(highlightedType)
    ? 'full'
    : 'small';
  const PromotedHeader =
    highlightedType === DEAL_WEEKEND || highlightedType === DEAL_HOTTEST
      ? DealHeader
      : HighlightedHeader;

  return (
    <PromotedHeader
      type={type}
      size={size}
      sx={{
        paddingBottom: '2x_small',
      }}
    >
      {children}
    </PromotedHeader>
  );
};

const HighlightedMessageText: FC<HighlightedMessageProps> = ({ type }) => {
  const { t } = useTranslation();
  return <>{t(`results.highlighted.itinerary.${type}`)}</>;
};

const HighlightedMessageHeader: FC<HighlightedMessageProps> = ({ type }) => (
  <>
    <Flex id="MYID" width="100%" justifyContent="space-between">
      <FlexRow
        flexDirection="row"
        alignItems="center"
        gap={type === 'deal' ? '2' : '1'}
      >
        <Col>
          <HighlightedMessageText type={type} />
        </Col>
      </FlexRow>
      <FlexRow flexDirection="row">
        <Reprice />
      </FlexRow>
    </Flex>
  </>
);

const HighlightedMessageDefault: FC<HighlightedMessageProps> = ({ type }) => (
  <FlexRow
    alignItems="center"
    gap={type === DEAL_WEEKEND || type === DEAL_HOTTEST ? '2' : '1'}
  >
    <Col>
      <HighlightedMessageText type={type} />
    </Col>
  </FlexRow>
);

const HighlightedMessage: FC<HighlightedMessageProps> = ({ type }) => {
  const { isUKDisplayType } = useDisplayTypeBySite();
  return !isUKDisplayType() ? (
    <HighlightedMessageHeader type={type} />
  ) : (
    <HighlightedMessageDefault type={type} />
  );
};

const ItineraryHeaderRevamp: FC<ItineraryHeaderRevampProps> = ({
  highlightedType = ' default',
}) => (
  <HeaderComponent
    highlightedType={highlightedType}
    sx={{
      paddingBottom: '2x_small',
    }}
  >
    <HighlightedMessage type={highlightedType} />
  </HeaderComponent>
);

export default ItineraryHeaderRevamp;
